import { NotifyHelper } from "../../../helpers/toast";
import { objNguonBietToiTypeDefine } from "../../action-types/crm-category/IDmNguonBietToiTypeActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";


export const nguonBietToiTypeActions = {
    ...generateActions(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE"),
    ...generateActionForKey(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
